import React from 'react';
import { Routes, Route } from "react-router-dom";
import Softphone from './components/Softphone/Softphone';
import Login from './components/Pages/Login';
import Dashboard from './components/Pages/Dashbord';
import Calls from './components/Pages/Calls';
import Chats from './components/Pages/Chats';
import Email from './components/Pages/Email';
import Callbacks from './components/Pages/Callbacks';
import Voicemails from './components/Pages/Voicemails';
import Setting from './components/Pages/Setting';
import Followups from './components/Pages/Followups';
import { useDispatch, useSelector } from "react-redux";

function App() {

	const agentObj = useSelector((state: any) => { return state.agentSlice.agentObj })
	window.addEventListener('unload', function (e) {
		if (agentObj.getState().name === "Offline" && agentObj.getState().type === "offline") {
			localStorage.removeItem('missedContactsAgent');
        	localStorage.removeItem('missedChatsAgent');
			// The agent's status is already set to offline.
			return;
		}
		this.localStorage.setItem('forcedLogout', 'true');
		localStorage.removeItem('missedContactsAgent');
        localStorage.removeItem('missedChatsAgent');
	});











	async function Getinfo(){
		let Medias =await navigator.mediaDevices.enumerateDevices()
		let Inbound = Medias.filter(Devices=>Devices.kind === "audioinput")
		let Outbound = Medias.filter(Devices=>Devices.kind === "audiooutput")
		console.log("Medias",JSON.stringify(Medias))
		localStorage.setItem("InputDevices", JSON.stringify(Inbound));
		localStorage.setItem("OutputDevices", JSON.stringify(Outbound));
		}
	try{
		Getinfo()
	}catch(e){
		console.log("No audio Devices even on site load",e)
	}

	const dispatch = useDispatch();
	/*console.info = function(msg) {
		dispatch(contactSliceAction.setConsoleStorage(msg+"\n"));
	}
	console.log = function(msg) {
		dispatch(contactSliceAction.setConsoleStorage(msg+"\n"));
	}
	console.warn = function(msg) {
		dispatch(contactSliceAction.setConsoleStorage(msg+"\n"));
	}
	console.error = function(msg) {
		dispatch(contactSliceAction.setConsoleStorage(msg+"\n"));
	}*/
	
	return (
		<React.Fragment>
			<Softphone></Softphone>
			<Routes>
				<Route path="/" element={<Login />} />
				<Route path="/login" element={<Login />} />
				<Route path="/dashboard" element={<Dashboard />} />
				<Route path="/calls" element={<Calls />} />
				<Route path="/chats" element={<Chats />} />
				<Route path="/email" element={<Email />} />
				<Route path="/callbacks" element={<Callbacks />} />				
				<Route path="/voicemails" element={<Voicemails />} />
				<Route path="/followups" element={<Followups />} />
				<Route path="/setting" element={<Setting />} />
				<Route path="*" element={<Login />} />
			</Routes>
			
		</React.Fragment>
	);
}

export default App;
